module.exports = __webpack_public_path__ + "img/video.1f5310ee.png";